export default "/img/SI.c268f3d95c444d7509bd171f7bcbda06.png";